module.exports = __webpack_public_path__ + "static/media/ad.8062e8a3.svg";